
import React from 'react';
import ReactDOM from 'react-dom';
import { PublicClientApplication } from "@azure/msal-browser";
import { MsalProvider } from "@azure/msal-react";
import './index.css';
import App from './containers/App';

//Import semantic-ui
import 'semantic-ui-react';

//Import CSS from semantic-UI
import 'semantic-ui-css/semantic.min.css';
//Import CSS from toastify
import 'react-toastify/dist/ReactToastify.css';
//Import CSS from 
import 'react-checkbox-tree/lib/react-checkbox-tree.css';
//Import CSS custom styles
import './styles/theme.scss'

// Authentication
import { msalConfig } from "auth/entra";
import './ReactotronConfig'

const msalInstance = new PublicClientApplication(msalConfig);

ReactDOM.render(
  <MsalProvider instance={msalInstance}>
    <App />
  </MsalProvider>, document.getElementById('root'));
